import React, { useEffect, useState } from 'react'

import toast from 'react-hot-toast';

import { 
  Form,
  Input,
  Col, 
  Row,
  Divider,
  Space,
  Button,
  Select,
} from 'antd';

// import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'

const { Item } = Form;
const { Option } = Select;

const AddressTab = ({addressData, id}) => {
    const [addressForm] = Form.useForm();
    const [billingAddress, setBillingAddress] = useState('home')
    const { callPost, loading } = usePostRequest(()=>{
      
    });

    const handleCreateAddress = () => {
        addressForm.validateFields().then(values => {
            const newValues = {
                member_id: id,
                home_address_1: values.home_address_1,
                home_address_2: values.home_address_2,
                home_telephone: values.home_telephone,
                home_fax: values.home_fax,
                business_address_1: values.business_address_1,
                business_address_2: values.business_address_2,
                business_telephone: values.business_telephone,
                business_fax: values.business_fax,
                mailing_label_1: values.mailing_label_1,
                mailing_label_2: values.mailing_label_2,
                mailing_label_3: values.mailing_label_3,
                mailing_label_4: values.mailing_label_4,
                email_address: values.email_address,
                senior_id: values.senior_id,
                billing_address: billingAddress,
            }

            callPost(
                "members/update_address", 
                newValues,
                false,
            );
        }).catch(errorInfo => {
          toast.error('Validation Failed ', errorInfo);
        });
    };

    const handleAddress = (e) => {
        setBillingAddress(e)
    }
    useEffect(() => {
        if(addressData){
            addressForm.setFieldsValue({
                home_address_1: addressData[0]?.home_address_1,
                home_address_2: addressData[0]?.home_address_2,
                home_telephone: addressData[0]?.home_telephone,
                home_fax: addressData[0]?.home_fax,
                business_address_1: addressData[0]?.business_address_1,
                business_address_2: addressData[0]?.business_address_2,
                business_telephone: addressData[0]?.business_telephone,
                business_fax: addressData[0]?.business_fax,
                mailing_label_1: addressData[0]?.mailing_label_1,
                mailing_label_2: addressData[0]?.mailing_label_2,
                mailing_label_3: addressData[0]?.mailing_label_3,
                mailing_label_4: addressData[0]?.mailing_label_4,
                email_address: addressData[0]?.email_address,
                senior_id: addressData[0]?.senior_id,
            });
        }
    }, [addressData, addressForm])
 
    return (
        <Row className='tab-container custom-padding'>
            <Col span={24}>
                <Row>
                    <Col span={24} align='right'>
                        <Form 
                            layout="vertical"
                        >
                            <Item
                                label="Billing Address"
                                name="billing_type"
                                className='address-cont'
                                rules={[{ required: true, message: 'Please enter your Billing Address!' },]}
                            >
                                <Select 
                                    align='left'
                                    placeholder="Select a Biling Address" 
                                    onChange={(e) => handleAddress(e)}
                                    defaultValue='home'
                                >
                                    <Option key='home' value='home'>Home Address</Option>
                                    <Option key='business' value='business'>Business Address</Option>
                                </Select>
                            </Item>
                        </Form>
                    </Col>
                </Row>
                <Form 
                    layout="vertical"
                    form={addressForm}
                >
                    <Divider className='divider-text'>HOME ADDRESS</Divider>
                    <Row className='responsive-inline responsive-width'>
                        <Col 
                            xs={24} sm={24} md={24} lg={24} xl={24}
                            className='p-2'
                        >
                            <Item
                                label="Address 1"
                                name="home_address_1"
                                className='p-0 m-0'
                                rules={billingAddress === "home" ? [{ required: true, message: 'Please enter your Home Address 1!' },] : []}
                            >
                                <Input/>
                            </Item>
                        </Col>
                    </Row>
                    <Row className='responsive-inline responsive-width'>
                        <Col 
                            xs={24} sm={24} md={24} lg={24} xl={24}
                            className='p-2'
                        >
                            <Item
                                label="Address 2"
                                name="home_address_2"
                                className='p-0 m-0'
                                rules={billingAddress === "home" ? [{ required: true, message: 'Please enter your Home Address 2!' },] : []}
                            >
                                <Input/>
                            </Item>
                        </Col>
                    </Row>
                    <Row className='responsive-inline responsive-width'>
                        <Col 
                            xs={24} sm={24} md={24} lg={12} xl={12}
                            className='p-2'
                        >
                            <Item
                                label="Telephone"
                                name="home_telephone"
                                className='p-0 m-0'
                                rules={billingAddress === "home" ? [{ required: true, message: 'Please enter your Home Telephone!' },] : []}
                            >
                                <Input/>
                            </Item>
                        </Col>
                        <Col 
                            xs={24} sm={24} md={24} lg={12} xl={12}
                            className='p-2'
                        >
                            <Item
                                label="Fax"
                                name="home_fax"
                                className='p-0 m-0'
                                // rules={billingAddress === "home" ? [{ required: true, message: 'Please enter your Fax!' },] : []}

                            >
                                <Input/>
                            </Item>
                        </Col>
                    </Row>
                    <Divider className='divider-text'>BUSINESS ADDRESS</Divider>
                    <Row className='responsive-inline responsive-width'>
                        <Col 
                            xs={24} sm={24} md={24} lg={24} xl={24}
                            className='p-2'
                        >
                            <Item
                                label="Address 1"
                                name="business_address_1"
                                className='p-0 m-0'
                                rules={billingAddress === "business" ? [{ required: true, message: 'Please enter your Business Address 1!' },] : []}
                            >
                                <Input/>
                            </Item>
                        </Col>
                    </Row>
                    <Row className='responsive-inline responsive-width'>
                        <Col 
                            xs={24} sm={24} md={24} lg={24} xl={24}
                            className='p-2'
                        >
                            <Item
                                label="Address 2"
                                name="business_address_2"
                                className='p-0 m-0'
                                rules={billingAddress === "business" ? [{ required: true, message: 'Please enter your Business Address 2!' },] : []}
                            >
                                <Input/>
                            </Item>
                        </Col>
                    </Row>
                    <Row className='responsive-inline responsive-width'>
                        <Col 
                            xs={24} sm={24} md={24} lg={12} xl={12}
                            className='p-2'
                        >
                            <Item
                                label="Telephone"
                                name="business_telephone"
                                className='p-0 m-0'
                                rules={billingAddress === "business" ? [{ required: true, message: 'Please enter your Business Telephone!' },] : []}
                            >
                                <Input/>
                            </Item>
                        </Col>
                        <Col 
                            xs={24} sm={24} md={24} lg={12} xl={12}
                            className='p-2'
                        >
                            <Item
                                label="Fax"
                                name="business_fax"
                                className='p-0 m-0'
                                // rules={billingAddress === "business" ? [{ required: true, message: 'Please enter your Fax!' },] : []}
                            >
                                <Input/>
                            </Item>
                        </Col>
                    </Row>
                    <Divider className='divider-text'>MAILING LABEL</Divider>
                    <Row className='responsive-inline responsive-width'>
                        <Col 
                            xs={24} sm={24} md={24} lg={24} xl={24}
                            className='p-2'
                        >
                            <Item
                                label="Label I"
                                name="mailing_label_1"
                                className='p-0 m-0'
                            >
                                <Input/>
                            </Item>
                        </Col>
                    </Row>
                    <Row className='responsive-inline responsive-width'>
                        <Col 
                            xs={24} sm={24} md={24} lg={24} xl={24}
                            className='p-2'
                        >
                            <Item
                                label="Label II"
                                name="mailing_label_2"
                                className='p-0 m-0'
                            >
                                <Input/>
                            </Item>
                        </Col>
                    </Row>
                    <Row className='responsive-inline responsive-width'>
                        <Col 
                            xs={24} sm={24} md={24} lg={24} xl={24}
                            className='p-2'
                        >
                            <Item
                                label="Label III"
                                name="mailing_label_3"
                                className='p-0 m-0'
                            >
                                <Input/>
                            </Item>
                        </Col>
                    </Row>
                    <Row className='responsive-inline responsive-width'>
                        <Col 
                            xs={24} sm={24} md={24} lg={24} xl={24}
                            className='p-2'
                        >
                            <Item
                                label="Label IV"
                                name="mailing_label_4"
                                className='p-0 m-0'
                            >
                                <Input/>
                            </Item>
                        </Col>
                    </Row>
                    <Row className='responsive-inline responsive-width'>
                        <Col 
                            xs={24} sm={24} md={24} lg={12} xl={12}
                            className='p-2'
                        >
                            <Item
                                label="Email Address"
                                name="email_address"
                                className='p-0 m-0'
                            >
                                <Input/>
                            </Item>
                        </Col>
                        <Col 
                            xs={24} sm={24} md={24} lg={12} xl={12}
                            className='p-2'
                        >
                            <Item
                                label="Senior Id"
                                name="senior_id"
                                className='p-0 m-0'
                            >
                                <Input/>
                            </Item>
                        </Col>
                    </Row>
                    <Row className='btn-footer'>
                        <Space className='p-2'>
                            <Button
                                onClick={handleCreateAddress}
                                loading={loading}
                                type='primary'
                                className='button-color btn-header'
                            >
                                Save
                            </Button>
                        </Space>
                    </Row>
                </Form>
            </Col>
        </Row>
    )
}
export default AddressTab
